import Loading from "@/components/Loading";
import { useTestProductModalContext } from "@/contexts/TestProductModalContext";
import BackArrow from "@/images/BackArrow";
import Modal from "@/tpo/Modal";
import { ActionIcon } from "@/v2/Buttons";

export default function BaseTestProductModal({
  productDetailView,
  organisationShop = false,
  bg: defaultBg = "white"
}) {
  /**
   * Both the normal shop and the practitioner shop will use this component.
   * Both will have to implement their own views.  This reduces the risk of
   * the wrong prices being shown.  Otherwise I think it might be easy for somebody
   * to change something not realising that it will affect the other view.
   */

  let bg = "white";

  let content = null;

  const {
    loading,
    selectTestProductId,
    selectedTestProductOptionId,
    selectedTestProductId,
    selectTestProductOptionId
  } = useTestProductModalContext();

  let dataComponentName = "TestProductModal";

  if (selectedTestProductId && loading) {
    content = <Loading />;
  } else if (selectedTestProductId && productDetailView) {
    bg = defaultBg;
    content = productDetailView;
  }

  if (!content) return null;

  return (
    <Modal
      maxWidth={1024}
      closeButton
      headerProps={{
        p: [20, 20, 40],
        bg: "transparent"
      }}
      bg={bg}
      show={!!content}
      close={() => {
        selectTestProductId(null);
      }}
      mode={["fullScreen", "fullScreen", "centered"]}
      title={
        selectedTestProductId &&
        selectedTestProductOptionId && (
          <ActionIcon
            color="dark"
            height={[40, 40, 48]}
            width={[40, 40, 48]}
            borderRadius="50%"
            onClick={() => selectTestProductOptionId(null)}
            variant="outline"
            style={{
              pointerEvents: "auto"
            }}
            size={null}
          >
            <BackArrow color="black" />
          </ActionIcon>
        )
      }
      data-component-name={dataComponentName}
    >
      {content}
      {organisationShop}
    </Modal>
  );
}
